import React from 'react';
import './ScoreBoard.scss';

const ScoreBoard = ({ players, activePlayerIndex }) => {
    return (
        <div className="scoreboard-container">
            {players.map((player, index) => (
                <div 
                    key={player.id} 
                    // On ajoute la classe 'active' si c'est le tour de ce joueur
                    className={`score-card ${index === activePlayerIndex ? 'active' : ''}`}
                    style={{ borderColor: player.color }}
                >
                    <div className="player-info">
                        <div className="player-badge" style={{ backgroundColor: player.color }}>
                            {String.fromCharCode(65 + index)}
                        </div>
                        <span className="player-name">{player.name}</span>
                    </div>
                    <div className="player-score" style={{ color: player.color }}>
                        {player.score} <span className="pts">pts</span>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ScoreBoard;